<template>
  <div>
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat dense elevation="0" color="transparent">
        <v-toolbar-title>
          <h4>Commission Invoices</h4>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0">
        <template>
          <v-data-table
            :headers="headers"
            :items="commissionInvoices"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.itemsPerPage"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            class="elevation-0 black--text"
          >
            <template slot="item" slot-scope="props">
              <tr @click="detail(props.item.id)">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    :value="isSelected"
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.supplierOrderNumber }}
                </td>
                <td class="text-left">
                  {{ props.item.orderNumber }}
                </td>

                <td class="text-left">
                  {{ props.item.currency }} {{ props.item.subTotal }}
                </td>
                <td class="text-left">
                  {{ props.item.currency }} {{ props.item.vat }}
                </td>
                <td class="text-left">{{ props.item.paid | boolFilter }}</td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]
import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers.js";
export default {
  props: {
    payload: {
      type: Object,
      default: () => {
        return {
          from: 0,
          to: 10
        };
      }
    },
    module: {
      type: String,
      default: "finance/LOAD_COMMISSION_INVOICES"
    },
    actions: {
      type: Boolean,
      default: true
    }
  },
  mixins: [Helpers],
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    },
    boolFilter: function(bool) {
      return bool ? "YES" : "NO";
    }
  },
  data() {
    let vm = this;
    return {
      supplierId: null,
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "Created At",
          align: "left",
          value: "supplierOrderNumber",
          sortable: false
        },
        {
          text: "Supplier Order #",
          align: "left",
          value: "supplierOrderNumber",
          sortable: false
        },
        {
          text: "Order #",
          align: "left",
          value: "orderNumber",
          sortable: false
        },
        {
          text: "Sub Total",
          align: "left",
          sortable: false,
          value: "subTotal"
        },
        {
          text: "Vat",
          align: "left",
          value: "vat"
        },
        {
          text: "Paid",
          align: "left",
          value: "paid"
        }
      ]
    };
  },
  computed: {
    commissionInvoices() {
      return this.$store.state.finance.commissionInvoices;
    },
    totalItems() {
      return this.$store.state.finance.total;
    }
  },
  watch: {
    selected(val) {
      val.length > 0
        ? this.$emit("enable-action")
        : this.$emit("disable-action");
    }
  },
  mounted() {
    this.getCommissionInvoices(this.payload);
  },
  methods: {
    async getCommissionInvoices(payload) {
      this.loading = true;
      await this.$store.dispatch(this.module, payload);
      this.loading = false;
    },
    updatePagination(pagination) {
      let payload = this.payload;
      (payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage),
        (payload.to =
          pagination.itemsPerPage === -1
            ? this.totalItems
            : pagination.itemsPerPage);
      this.getCommissionInvoices(payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        let payload = {
          from:
            this.pagination.page * this.pagination.itemsPerPage -
            this.pagination.itemsPerPage,
          to:
            this.pagination.itemsPerPage === -1
              ? this.totalItems
              : this.pagination.itemsPerPage
        };
        this.getCommissionInvoices(payload);
      }
    },
    detail(id) {
      this.$router.push({
        name: "commissioninvoice-detail",
        params: { id: id }
      });
    }
  }
};
</script>
